<script setup lang="ts">
import NavBar from './layout/NavBar.vue'
</script>

<template>
  <div class="app-layout">
    <NavBar />
    <main id="main-content" class="app-main" role="main" aria-label="Main content">
      <slot />
    </main>
  </div>
</template>

<style scoped>
.app-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #fafafa;
}

.app-main {
  flex: 1;
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  padding: 2rem;
}
</style>
